import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HabilitationService {
  enableEdit = signal(false);
  private resourceUrl = `${environment.SERVER_UTILISATEUR_API_URL}/api/role-ressources`;

  constructor(private http: HttpClient) {}

  toggleEdit() {
    this.enableEdit.update((v) => !v);
  }

  affectationRolesEnMasse(code: string, ressourceType: string, roleIds: string[], moduleCode?: string) {
    const body = { code, ressourceType, roleIds, moduleCode };
    return this.http.post<any>(`${this.resourceUrl}/ajouter-roles`, body).pipe(
      map((res: Response) => {
        return res;
      })
    );
  }

  suppAffectationRolesEnMasse(code: string, ressourceType: string, roleIds: string[]) {
    const body = { code, ressourceType, roleIds };
    return this.http.post<any>(`${this.resourceUrl}/supprimer-roles`, body).pipe(
      map((res: Response) => {
        return res;
      })
    );
  }

  affectationRessourcesEnMasse(roleId: number, ressourceType: string, ressourceIds: string[]) {
    const body = { roleId, ressourceType, ressourceIds };
    return this.http.post<any>(`${this.resourceUrl}/ajouter-ressources`, body).pipe(
      map((res: Response) => {
        return res;
      })
    );
  }

  suppAffectationRessourcesEnMasse(roleId: number, ressourceType: string, ressourceIds: string[]) {
    const body = { roleId, ressourceType, ressourceIds };
    return this.http.post<any>(`${this.resourceUrl}/supprimer-ressources`, body).pipe(
      map((res: Response) => {
        return res;
      })
    );
  }
}
